import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { HTTP_HEADERS } from '../../constants/http-headers.const';
import { API_ENDPOINTS } from '../../constants/api-endpoints.const';
import { TenantService } from '../services/tenant.service';
import { TokenService } from '../services/token.service';

const PUBLIC_AUTH_PATHS: readonly string[] = [
  API_ENDPOINTS.AUTH.LOGIN,
  API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
  API_ENDPOINTS.AUTH.RESET_PASSWORD,
  API_ENDPOINTS.AUTH.REFRESH,
];

function isPublicAuthRequest(url: string): boolean {
  return PUBLIC_AUTH_PATHS.some((path) => url.includes(path));
}

/**
 * Appends `x-tenant-name` and `Authorization` when absent on the outgoing request.
 */
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const tenantService = inject(TenantService);

  const headers: Record<string, string> = {};
  const tenant = tenantService.tenantName();
  const token = tokenService.getToken();
  const skipAuth = isPublicAuthRequest(req.url);

  if (tenant && !req.headers.has(HTTP_HEADERS.TENANT_NAME)) {
    headers[HTTP_HEADERS.TENANT_NAME] = tenant;
  }

  if (token && !skipAuth && !req.headers.has(HTTP_HEADERS.AUTHORIZATION)) {
    headers[HTTP_HEADERS.AUTHORIZATION] = `Bearer ${token}`;
  }

  if (Object.keys(headers).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders: headers }));
};
